/**
 * TanStack Query hooks for `customizable-dashboards`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customizableDashboardsQueryKeys,
	type CreateCustomizableDashboardsBody,
	type ListCustomizableDashboardsResponse,
	type CustomizableDashboardsRow,
} from "./api";

export function useCustomizableDashboardsList(): UseQueryResult<ListCustomizableDashboardsResponse, Error> {
	return useQuery({
		queryKey: customizableDashboardsQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomizableDashboardsCreate(): UseMutationResult<CustomizableDashboardsRow, Error, CreateCustomizableDashboardsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customizableDashboardsQueryKeys.all });
		},
	});
}

export function useCustomizableDashboardsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customizableDashboardsQueryKeys.all });
		},
	});
}
